<template>
  <v-row :style="{ maxWidth: width }">
    <v-col cols="12" md="4">
      <input-date-picker
        v-model="startDate"
        :label="startDateLabel"
        :max-date="maxDate"
        :min-date="minDate"
        :errors="startDateErrors"
        :date-format="dateFormat"
      />
    </v-col>
    <v-col cols="12" md="4">
      <input-date-picker
        v-model="endDate"
        :label="endDateLabel"
        :max-date="maxDate"
        :min-date="minDateBasedOnStartDate"
        :errors="endDateErrors"
        :date-format="dateFormat"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
        :loading="loading"
        :disabled="loading"
        depressed
        block
        class="red-button"
        width="auto"
        @click="emitChanges"
      >
        {{ buttonLabel }}
      </v-btn>
      <v-btn
        v-if="startDate || endDate"
        text
        class="m-1 p-2"
        @click="emitReset"
      >
        <v-icon class="mr-1"> mdi-close-circle </v-icon>
        Borrar Fechas
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  import InputDatePicker from '@/components/InputDatePicker.vue';
  import moment from 'moment';

  export default {
    name: 'DateRangeSelector',

    components: {
      InputDatePicker,
    },

    props: {
      minDate: {
        type: Date,
        default: null,
      },

      maxDate: {
        type: Date,
        default: () => new Date(),
      },

      startDateLabel: {
        type: String,
        default: 'Fecha inicial',
      },

      endDateLabel: {
        type: String,
        default: 'Fecha final',
      },

      dateFormat: {
        type: String,
        default: 'YYYY-MM-DD',
      },

      buttonLabel: {
        type: String,
        default: 'Ejecutar',
      },

      width: {
        type: String,
        default: '9000px',
      },

      loading: Boolean,
      endDateOptional: Boolean,
    },

    data() {
      return {
        startDate: null,
        endDate: null,

        endDateErrors: '',
        startDateErrors: '',
      };
    },

    computed: {
      minDateBasedOnStartDate() {
        if (this.startDate === null) return this.minDate;

        const d = moment(this.startDate, this.dateFormat, true);

        return d.toDate();
      },
    },

    watch: {
      startDate(newVal) {
        const start = moment(newVal, this.dateFormat, true);
        const end = moment(this.endDate, this.dateFormat, true);

        if (this.endDate !== null && start.isAfter(end)) {
          this.endDate = null;
        }
      },
    },

    methods: {
      emitChanges() {
        this.endDateErrors = '';
        this.startDateErrors = '';
        let errorInDates = false;

        if (this.startDate === null && this.endDate !== null) {
          this.startDateErrors = 'Introduce esta fecha';
          errorInDates = true;
        }

        if (
          !this.endDateOptional &&
          this.endDate === null &&
          this.startDate !== null
        ) {
          this.endDateErrors = 'Introduce esta fecha';
          errorInDates = true;
        }

        if (
          !errorInDates ||
          (this.startDate === null && this.endDate === null)
        ) {
          const dates = {
            startDate: this.startDate,
            endDate: this.endDate,
          };

          this.$emit('onClick', dates);
        }
      },

      emitReset() {
        this.startDate = null;
        this.endDate = null;
        this.$emit('onReset');
      },
    },
  };
</script>
